import React from 'react';
import { ElevesDashboardProf } from 'types/classe/maClasse';
import { GoToSinglePage } from 'helpers/page/goToPage';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { MobileTabLineBox } from 'components/atoms/Texts/MobileTabLineBox';
import { sanitizePrice } from 'helpers/number/sanitizeCalul';
import { WarningHeaderBlock } from 'components/molecules/Blocks/WarningHeaderBlock';

export interface TableMyResultContentProps {
  numberOfCommandePaymentReminder?: number;
  eleves: ElevesDashboardProf[];
  toElevePage: GoToSinglePage;
}

export const MobileTabLineVentes = ({
  numberOfCommandePaymentReminder,
  eleves,
  toElevePage
}: TableMyResultContentProps) => (
  <>
    <FeatureContainer padding="mobileTab">
      <WarningHeaderBlock
        variant="EspaceProf"
        numberOfOrders={
          numberOfCommandePaymentReminder && numberOfCommandePaymentReminder
        }
      />
    </FeatureContainer>
    {eleves.map(
      eleve =>
        eleve.note && (
          <FeatureContainer key={eleve.id} padding="mobileTab">
            <MobileTabLineBox
              texts={[
                { text: eleve?.lastname, style: 'bold' },
                { text: eleve?.firstname, style: 'bold' },
                { text: eleve.note.qtevente + ' vente(s)' },
                { text: eleve.note.qtepro + ' vente(s) pro' },
                { text: eleve.note.qterebond + ' vente(s) rebond' }
              ]}
              variant={eleve.orderNeedToBeReminded > 0 ? 'orange' : 'default'}
            />
            <MobileTabLineBox
              title="CA (hors port)"
              texts={[
                {
                  text: `${sanitizePrice(eleve.note.qteca.toString())} €`,
                  style: 'bold'
                }
              ]}
              variant={eleve?.orderNeedToBeReminded > 0 ? 'orange' : 'default'}
            />
            <MobileTabLineBox
              title="CA en attente (CB, Mandats, Virements)"
              variant={eleve.unpayedCa > 0 ? 'red' : 'default'}
              texts={[
                { text: `${sanitizePrice(eleve.unpayedCa.toString())} €` }
              ]}
            />
            <ButtonWithText
              variant="mobileTab"
              onClick={() => toElevePage({ id: eleve.id })}
              icon={'Form'}
              content="Détails"
            />
          </FeatureContainer>
        )
    )}
  </>
);
